import { Field, Textfield } from "@digdir/designsystemet-react";
import type { InputHTMLAttributes } from "react";
import { type FieldError, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { HelpText } from "../components";
import type { bestillerPrivatFormValues } from "./BestillerPrivatFormSchemas";
import type { bestillerSelskapFormValues } from "./BestillerSelskapFormSchemas";

type TekstfeltComponentProps = {
  className?: string;
  feltKey: keyof bestillerSelskapFormValues | keyof bestillerPrivatFormValues;
  labelTranslationPrefix: string;
  readOnly?: boolean;
  type?: "text" | "number" | "email";
  prefix?: string;
  suffix?: string;
  hjelpeTekst?: boolean;
} & InputHTMLAttributes<HTMLInputElement>;

export const Tekstfelt = ({
  feltKey,
  labelTranslationPrefix,
  readOnly,
  className,
  type = "text",
  prefix,
  suffix,
  hjelpeTekst = false,
  ...rest
}: TekstfeltComponentProps) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const error = errors[feltKey] as FieldError | undefined;
  const formlabelTranslationPrefix = `${labelTranslationPrefix}.felt`;
  const hjelpeTekstLabelTranslationKey = `${labelTranslationPrefix}.hjelpetekst`;
  return (
    <Field className={className}>
      <Textfield
        id={feltKey}
        readOnly={readOnly}
        type={type}
        {...register(feltKey)}
        label={
          <HelpText
            feltKey={feltKey}
            hjelpeTekstLabelTranslationKey={hjelpeTekstLabelTranslationKey}
            enabled={hjelpeTekst}
          >
            <span>{t(formlabelTranslationPrefix, { context: feltKey })}</span>
          </HelpText>
        }
        error={error?.message && <span>{t(error?.message)}</span>}
        prefix={prefix}
        suffix={suffix}
        // Remove aria-label and aria-labelledby from rest to avoid prop type conflict
        {...Object.fromEntries(
          Object.entries(rest).filter(
            ([key]) => key !== "aria-label" && key !== "aria-labelledby",
          ),
        )}
      />
    </Field>
  );
};
